import {
  handleAuth as commonHandleAuth,
  reloadWindowOnStorageChange as commonReloadWindowOnStorageChange,
  AuthState,
} from '@amzn/d2c-application-website-common';
import {Dispatch} from '@reduxjs/toolkit';
import { store, storageKey } from 'src/store/store';
import { setAuthInProgress, setAuthState } from 'src/store/authSlice';
import { awsRum } from 'src/rum';
import {LOCAL_HOSTNAME} from "src/constants/appConstants";

export const handleAuth = (clientId: string, redirectUrl: string) => {
  const { getStorageScope } = require('src/store/store');
  const scope = getStorageScope() || undefined;
  commonHandleAuth(clientId, redirectUrl, store, setAuthInProgress, (context, error, status) => {
    awsRum?.recordEvent('LWAError', { context, error: String(error), status });
  }, scope);
};

export const reloadWindowOnStorageChange = (dispatch: Dispatch, prevValue: AuthState) => {
  return commonReloadWindowOnStorageChange(dispatch, prevValue, setAuthState, storageKey('authState'));
};

export const isLocalHost = (): boolean => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '0.0.0.0' || hostname === '127.0.0.1' || hostname === LOCAL_HOSTNAME;
};

const DEPLOYMENT_VARIANT = 'live';

export const isPreviewHost = (): boolean => {
  return isLocalHost()
    || DEPLOYMENT_VARIANT.toLowerCase() === 'preview'
    || window.location.hostname.includes('preview');
};
